import type {
	SettingsFlow,
	UpdateSettingsFlowBody,
	UpdateSettingsFlowWithWebAuthnMethod,
} from "@ory/kratos-client";
import type React from "react";
import { Flow } from "~/components/KratosFlow";

interface Props {
	flow: SettingsFlow;
	onSubmit: (values: UpdateSettingsFlowBody) => Promise<void>;
}

export const WebAuthnSettings: React.FC<Props> = ({ flow, onSubmit }) => {
	return (
		<Flow<UpdateSettingsFlowWithWebAuthnMethod & { method: "webauthn" }>
			onSubmit={onSubmit}
			flow={flow}
			only="webauthn"
			sortComponents={[
				{ name: "webauthn_register_displayname" },
				{ name: "webauthn_register_trigger" },
				{ name: "webauthn_remove" },
			]}
			setLabelTypes={[
				{
					query: { name: "webauthn_remove", type: "submit" },
					value: "error",
				},
			]}
			beforeComponents={[
				{
					query: { name: "webauthn_register_displayname" },
					component: Caption,
				},
			]}
			nodeDisablers={[
				{
					target: { name: "webauthn_register_trigger" },
					keys: ["webauthn_register_displayname"],
					allowEmpty: false,
					allowNotChanged: false,
				},
			]}
		/>
	);
};

const Caption: React.FC = () => (
	<p className="mt-6">
		Use Hardware Tokens (e.g. YubiKey) or Biometrics (e.g. FaceID, TouchID) to
		enhance your account security.
	</p>
);
